/** Estado vazio com ícone, título, descrição e ação opcional. */
import { createElement as h, type ReactElement, type ReactNode } from "react";
import { Inbox, type LucideIcon } from "lucide-react";

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon = Inbox, action }: EmptyStateProps): ReactElement {
  return h(
    "div",
    {
      role: "status",
      className:
        "flex flex-col items-center gap-2 rounded-panel border border-dashed border-border-strong bg-surface p-6 text-center"
    },
    h(
      "span",
      { className: "grid h-12 w-12 place-items-center rounded-pill bg-brand-wash text-brand-text" },
      h(icon, { className: "h-6 w-6", "aria-hidden": true, focusable: false })
    ),
    h("p", { className: "text-base font-bold text-ink" }, title),
    description ? h("p", { className: "max-w-md text-sm text-muted" }, description) : null,
    action ?? null
  );
}
